<template>
  <div class="map">
    <div class="map-dom" ref="map"></div>
    <div class="input">
      <input id="refInput" type="text"  placeholder="请输入地址" />
      <el-button v-if="cover" type="primary" size="small" @click="onClear">重新绘制</el-button>
    </div>
  </div>
</template>
<script>
import GPS from '@/assets/js/GPS.js';
export default {
  name:'FenceMap',
  props:{
    formData:{
      type:Object,
      default:() => {}
    },
    pathId: {
      type: Number,
      default:null
    },
    visible:{
      type:Boolean,
      default:false
    }
  },
  data(){
    return {
      /** 地图 */
      map:null,
      autoComplete:null,
      address:'',
      mouseTool:null,
      cover:null,
      placeSearch:null
    }
  },
  async mounted(){
    await this.$sleep();
    await this.initMap();
    this.onSearchAddress();
  },
  methods: {
    // 清空全部覆盖物
    clearMap(){
      this.map.clearMap();
    },
    // 添加覆盖物
    async drawCover(){
      await this.$sleep();
      if(this.pathId){
        if(this.formData.regionShape == 1){
          let path = []
          this.formData.pointList.map(item => {
            path.push([ item.oriLon, item.oriLat ]);
          });
          this.cover = new AMap.Polygon({
            path,
            fillColor: '#ccebc5',
            strokeOpacity: 1,
            fillOpacity: 0.5,
            strokeColor: '#2b8cbe',
            strokeWeight: 1,
            strokeStyle: 'dashed',
          });
          this.map.setCenter(path[0]);
        }else{
          const { lon, lat } = this.formData;
          const radius = this.formData.radius * 1000;
          this.cover = new AMap.Circle({
            center: [lon, lat],
            radius, //半径
            borderWeight: 3,
            strokeColor: "#FF33FF",
            strokeOpacity: 1,
            strokeWeight: 6,
            strokeOpacity: 0.2,
            fillOpacity: 0.4,
          })
          this.map.setCenter([lon, lat]);
        }
        this.map.setZoom(15)
        this.cover && this.map.add(this.cover);
      }
    },
    // 渲染地图
    initMap() {
      this.map = new AMap.Map(this.$refs.map, {
        center: [116.408868,39.912943],
        zoom: 8,
        resizeEnable:true
      });
      this.placeSearch = new AMap.PlaceSearch({
        map: this.map
      });  //构造地点查询类
      this.initDraw();
    },
    // 搜索地址
    onSearchAddress(){
      AMap.plugin('AMap.Autocomplete', () => {
        // 实例化Autocomplete
        let autoOptions = {
          //city 限定城市，默认全国
          city: '全国',
          input:'refInput'
        }
        this.autoComplete = new AMap.Autocomplete(autoOptions);
        this.autoComplete.on("select", (e) => {
          let { district, location } = e.poi;
          this.initPlaceSearch(e);
          // if(location){
          //   this.map.setCenter([ location.lng, location.lat ]);
          // }else{
          //   this.map.setCity(district)
          // }

        });
      })
    },
    // 绘制覆盖物
    async drawType(type){
      this.cover = null;
      if(!this.mouseTool) {
        await this.$sleep(500);
      };
      switch(type){
        case 'polygon':{
          this.mouseTool.polygon({
            fillColor:'#00b0ff',
            strokeColor:'#80d8ff'
            //同Polygon的Option设置
          });
          break;
        }
        case 'circle':{
          this.mouseTool.circle({
            fillColor:'#00b0ff',
            strokeColor:'#80d8ff'
            //同Circle的Option设置
          });
          break;
        }
      }
    },
    // 初始化绘制
    initDraw(){
      this.mouseTool = new AMap.MouseTool(this.map);
      this.mouseTool.on('draw', (e) => {
        this.cover = e.obj;
        if(this.formData.regionShape == 1){
          const points = e.obj.getPath().map(item => {
            return { oriLon:item.lng, oriLat:item.lat };
          });
          this.$emit('drawConfirm',points);
        }else{
          const point = e.obj.getCenter();
          const radius = e.obj.getRadius();
          this.$emit('drawConfirm',{
            lon:point.lng,
            lat:point.lat,
            radius:Math.floor((radius/1000) * 1000) / 1000
          });
        }

        this.mouseTool.close();
      });
    },
    initPlaceSearch(e){
      this.placeSearch.setCity(e.poi.adcode);
      this.placeSearch.search(e.poi.name);  //关键字查询查询
    },
    // 重新绘制
    onClear(){
      this.cover && this.map.remove(this.cover);
      this.drawType(this.formData.regionShape == 1 ? 'polygon' : 'circle');
    }
  },
}
</script>
<style lang="scss" scoped>
.map{
  width: 60%;
  height: 100%;
  position: relative;
  background: #eee;
  .input{
    position: absolute;
    left: 10px;
    top: 10px;
    >input{
      background: #FFF;
      height: 32px;
      border: 1px solid #ccc;
      padding: 10px;
      border-radius: 3px;
      box-sizing: border-box;
      box-shadow: none;
      resize: none;
      margin-right: 10px;
    }
  }
  &-dom{
    width: 100%;
    height: 100%;
  }
}
</style>
<style>
.amap-sug-result{
  z-index: 100000;
}
</style>
